// Shared game-export utilities. Extracted from GameHistory so the mobile
// KebabMenu can trigger the same exports without pulling in the desktop
// game-history sidebar.

const PIECE_TO_ASCII = {
  king:    { white: 'K', black: 'k' },
  advisor: { white: 'A', black: 'a' },
  camel:   { white: 'M', black: 'm' },
  knight:  { white: 'N', black: 'n' },
  donkey:  { white: 'D', black: 'd' },
  cannon:  { white: 'C', black: 'c' },
  ram:     { white: 'R', black: 'r' },
  spy:     { white: 'S', black: 's' },
  pawn:    { white: 'P', black: 'p' },
};

function download(filename, content, mime = 'text/plain') {
  const blob = new Blob([content], { type: mime });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

const FILES = ['a','b','c','d','e','f','g','h','i'];
const RANKS = ['1','2','3','4','5','6','7','8','9'];

const PIECE_LETTERS = {
  king: 'K', knight: 'N', pawn: '', advisor: 'A',
  cannon: 'C', camel: 'M', donkey: 'D', ram: 'R', spy: 'S',
};

function coordsToAlgebraic(row, col) {
  if (row == null || col == null) return '??';
  return `${FILES[col]}${RANKS[row]}`;
}

function moveToAlgebraic(m) {
  if (m.algebraic_notation) return m.algebraic_notation;
  const pieceType = m.piece_type || m.piece;
  const piece = PIECE_LETTERS[pieceType] || '';
  const from = coordsToAlgebraic(m.from_row ?? m.from?.row, m.from_col ?? m.from?.col);
  const to   = coordsToAlgebraic(m.to_row   ?? m.to?.row,   m.to_col   ?? m.to?.col);
  const captured = m.captured_piece || m.captured;
  let capMark = '';
  if (captured) capMark = m.is_ram_bump && pieceType === 'ram' ? '-' : 'x';
  if (pieceType === 'pawn' && capMark) return `${from[0]}${capMark}${to}`;
  return `${piece}${from}${capMark}${to}`;
}

export function exportBoardPosition(board) {
  if (!board) {
    alert('No board position to export');
    return;
  }
  let out = '';
  for (let rank = 9; rank >= 1; rank--) {
    const row = rank - 1;
    let line = String(rank);
    for (let col = 0; col < 9; col++) {
      const piece = board[row] && board[row][col];
      const glyph = piece && PIECE_TO_ASCII[piece.type] ? PIECE_TO_ASCII[piece.type][piece.color] : '';
      line += '\t' + glyph;
    }
    out += line + '\n';
  }
  out += '\ta\tb\tc\td\te\tf\tg\th\ti\n';
  download(`board_position_${new Date().toISOString().slice(0, 10)}.txt`, out, 'text/plain');
}

export function exportGameHistoryCsv({ moves, gameData }) {
  if (!moves || moves.length === 0) {
    alert('No game history to export');
    return;
  }
  const rows = [];
  rows.push(['Move Number', 'Player', 'Piece', 'From', 'To', 'Captured', 'Algebraic Notation']);
  rows.push(['Game Info', '', '', '', '', '', '']);
  rows.push(['White Player', gameData?.whitePlayerName || 'Unknown', '', '', '', '', '']);
  rows.push(['Black Player', gameData?.blackPlayerName || 'Unknown', '', '', '', '', '']);
  rows.push(['Game Mode',    gameData?.gameMode        || 'Unknown', '', '', '', '', '']);
  rows.push(['Export Date',  new Date().toISOString(),               '', '', '', '', '']);
  rows.push(['', '', '', '', '', '', '']);
  moves.forEach((m, i) => {
    const moveNumber = Math.floor(i / 2) + 1;
    const player = m.player_color || (i % 2 === 0 ? 'white' : 'black');
    const from = coordsToAlgebraic(m.from_row, m.from_col);
    const to   = coordsToAlgebraic(m.to_row, m.to_col);
    rows.push([moveNumber, player, m.piece_type || '', from, to, m.captured_piece || '', moveToAlgebraic(m)]);
  });
  const csv = rows.map((r) => r.map((cell) => {
    const s = String(cell ?? '');
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  }).join(',')).join('\n');
  download(`game_history_${new Date().toISOString().slice(0, 10)}.csv`, csv, 'text/csv');
}
